import React from 'react';
import PropTypes from 'prop-types';
import {getTickY} from 'utils/layout-util';
import {getTicks} from 'utils/tick-util';
import styles from './index.css';

export default class HorizontalGridLines extends React.Component {
  static propTypes = {
    numTicks: PropTypes.number,
    scale: PropTypes.func,
    width: PropTypes.number,
  };

  static defaultProps = {
    numTicks: 0,
    scale: () => {},
    width: 0,
  };

  render() {
    const ticks = getTicks(this.props.scale, this.props.numTicks);
    return (
      <g className={styles.HorizontalGridLines}>
        {ticks.map((datum, index) => {
          const tickY = getTickY(this.props.scale, datum);
          return (
            <line
              key={index}
              x1={0}
              x2={this.props.width}
              y1={tickY}
              y2={tickY}
            />
          );
        })}
      </g>
    );
  }
}
